import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "path3" }, null, -1)
const _hoisted_4 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "d-flex flex-column pe-0 pe-sm-10" }
const _hoisted_6 = { class: "mb-1" }
const _hoisted_7 = { style: {"word-break":"break-all"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.data.class)
  }, [
    _createElementVNode("i", {
      class: _normalizeClass(`las la-3x ${_ctx.data.icon} me-4 mb-5 mb-sm-0`)
    }, _hoisted_4, 2),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.data.title), 1),
      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.data.description), 1)
    ])
  ], 2))
}